import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Points, marginLevel } from '@styles';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Grid } from 'planoplan-ui-kit/core/helpers/grid';
import { IS_CLIENT } from '@constants';

export const Widget = ({ id, image, title }) => {
  const contentRef = React.createRef();

  const initWidget = () => {
    if (!id || !window.Planoplan) {
      return;
    }

    const idEl = 'project-widget';

    contentRef.current.innerHTML = `<div id="${idEl}"></div>`;
    window.Planoplan.init({
      width: '100%',
      height: '100%',
      uid: id,
      hideVr: true,
      el: idEl,
    });
  };

  useEffect(() => {
    if (IS_CLIENT && id) {
      if (window.Planoplan) {
        initWidget();

        return;
      }

      const script = document.createElement('script');

      script.src = `https://widget.planoplan.com/etc/multiwidget/release/v4/static/js/main.js`;
      script.async = true;
      script.onload = () => initWidget();

      document.body.appendChild(script);
    }
  }, [id]);

  return (
    <Container>
      {id ? <Content ref={contentRef}/> : <Content><img src={image} alt={title}/></Content>}
    </Container>
  );
};

const Container = styled.div`
  ${marginLevel('top', 'whisper')};
  border: 1px solid ${Colors.night};
  border-radius: 20px; 
  overflow: hidden;
  position: relative;
  height: 460px;
  
  @media ${Points.tablet_portrait} {
    height: 580px;
  }
  
  @media ${Points.laptop} {
    ${Grid.push(-2)};
    padding-top: 71.4%;
    height: 0;
  }
`;

const Content = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${Colors.white};
  
  
  @media ${Points.laptop} {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }
  
  & > div {
    width: 100%;
    height: 100%;
  }
  
  & > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
